import React from "react";
import * as Icon from "react-feather";
import * as MP from "../contants/permissions";

const horizontalMenuConfig = [
   {
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      icon: <Icon.Home size={16}/>,
      navLink: "/",
   },
   {
      id: "sales",
      title: "Sales",
      type: "dropdown",
      icon: <Icon.Package size={16}/>,
      children: [
         {
            id: "export",
            title: "Export",
            type: "item",
            icon: <Icon.ShoppingBag size={16}/>,
            navLink: "/export",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "local-sales",
            title: "Local Sales",
            type: "item",
            icon: <Icon.Inbox size={16}/>,
            navLink: "/sales",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "credit-note",
            title: "Credit Note",
            type: "item",
            icon: <Icon.AlertOctagon size={16}/>,
            navLink: "/credit-notes",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "vds-receive",
            title: "VDS Receive",
            type: "item",
            icon: <Icon.XSquare size={16}/>,
            navLink: "/vds-receive-list",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "treasury-deposit",
            title: "Treasury Deposit",
            type: "item",
            icon: <Icon.Inbox size={16}/>,
            navLink: "/treasury-deposit",
            permissions: ["admin", "super", "editor"]
         },
      ]
   },
   {
      id: "purchase",
      title: "Purchase",
      type: "dropdown",
      icon: <Icon.Truck size={16}/>,
      children: [
         {
            id: "imports",
            title: "Imports",
            type: "item",
            icon: <Icon.ShoppingCart size={16}/>,
            navLink: "/purchases",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "local-purchase",
            title: "Local Purchases",
            type: "item",
            icon: <Icon.Book size={16}/>,
            navLink: "/local-purchases",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "debit-notes",
            title: "Debit Note",
            type: "item",
            icon: <Icon.XOctagon size={16}/>,
            navLink: "/debit-notes",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "vds-issue",
            title: "VDS Issue",
            type: "item",
            icon: <Icon.AlertTriangle size={16}/>,
            navLink: "/vds-issue-list",
            permissions: ["admin", "super", "editor"]
         }
      ]
   },
   {
      id: "products-and-ingredients",
      title: "Inventories",
      type: "dropdown",
      icon: <Icon.List size={16}/>,
      children: [
         {
            id: "raw-materials",
            title: "Raw Materials/Service",
            type: "item",
            icon: <Icon.Codesandbox size={16}/>,
            navLink: "/raw-materials",
            permissions: ["admin", "super", "editor"]
         },
         {

            id: "product-service",
            title: "Product/Service",
            type: "item",
            icon: <Icon.Archive size={16}/>,
            navLink: "/product-service",
            permissions: ["admin", "super", "editor"]
         },

         {
            id: "products-receive",
            title: "Production",
            type: "item",
            icon: <Icon.ArrowDown size={16}/>,
            navLink: "/products-receive",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "surcharge",
            title: "Surcharge",
            type: "item",
            icon: <Icon.Anchor size={16}/>,
            navLink: "/surcharge/create",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "transfer-voucher",
            title: "Transfer Raw Materials",
            type: "item",
            icon: <Icon.Database size={16}/>,
            navLink: "/transfers",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "transfer-product",
            title: "Transfer Products",
            type: "item",
            icon: <Icon.Briefcase size={16}/>,
            navLink: "/transfer-products",
            permissions: ["admin", "super", "editor"]
         },

      ]
   },
   // {
   //   id: "transfers",
   //   title: "Transfer",
   //   type: "dropdown",
   //   icon: <Icon.Move size={16} />,
   //     children: [
   //        {
   //           id: "product-transfer",
   //           title: "Product Transfer",
   //           type: "item",
   //           icon: <Icon.Package size={16}/>,
   //           navLink: "/product-transfer",
   //           permissions: ["admin", "super", "editor"]
   //        }
   //     ]
   // },
   {
      id: "reports",
      title: "Reports",
      type: "dropdown",
      icon: <Icon.FileText size={16}/>,
      children: [
         {
            id: "mushaks",
            title: "Mushaks",
            type: "item",
            icon: <Icon.FileText size={16}/>,
            navLink: "/reports/mushaks",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "first-tofshil",
            title: "First Schedules",
            type: "item",
            icon: <Icon.Sliders size={16}/>,
            navLink: "/first-tofshil-lists",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "second-tofshil",
            title: "Second Schedules",
            type: "item",
            icon: <Icon.Layers size={16}/>,
            navLink: "/second-tofshil-lists",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "third-tofshil",
            title: "Third Schedules",
            type: "item",
            icon: <Icon.Crosshair size={16}/>,
            navLink: "/third-tofshil-lists",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "fourth-tofshil",
            title: "Products On 15% VAT",
            type: "item",
            icon: <Icon.Framer size={16}/>,
            navLink: "/fourth-tofshil-lists",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "tariff-schedules-lists",
            title: "Tariff Schedules",
            type: "item",
            icon: <Icon.Wind size={16}/>,
            navLink: "/tariff-schedules-lists",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "backup-list",
            title: "Backup List",
            type: "item",
            icon: <Icon.CloudSnow size={16}/>,
            navLink: "/back-up-list",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "stock-report",
            title: "Stock Report",
            type: "item",
            icon: <Icon.Archive size={16}/>,
            navLink: "/stock-report",
            permissions: ["admin", "super", "editor"]
         },
         // {
         //    id: "products-with-vds",
         //    title: "Products With VDS",
         //    type: "item",
         //    icon: <Icon.AlertOctagon size={16}/>,
         //    navLink: "/products-with-vds",
            // permissions: ["admin", "super", "editor"]
         // },
      ]
   },
   {
      id: "settings",
      title: "Settings",
      type: "dropdown",
      icon: <Icon.Settings size={16}/>,
      children: [
         {
            id: "accountSettings",
            title: "Account Settings",
            type: "item",
            icon: <Icon.Settings size={16}/>,
            navLink: "/account-settings",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "userList",
            title: "Users",
            icon: <Icon.Users size={16}/>,
            type: "item",
            navLink: "/users",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "userRoles",
            title: "Roles",
            icon: <Icon.Award size={16}/>,
            type: "item",
            navLink: "/roles",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "userPermissions",
            title: "Permissions",
            icon: <Icon.Award size={16}/>,
            type: "item",
            navLink: "/permissions",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "categories",
            title: "Categories",
            icon: <Icon.Grid size={16}/>,
            type: "item",
            navLink: "/categories",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "suppliers",
            title: "Suppliers",
            icon: <Icon.Users size={16}/>,
            type: "item",
            navLink: "/suppliers",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "customers",
            title: "Customers",
            icon: <Icon.Users size={16}/>,
            type: "item",
            navLink: "/customers",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "product-sizes",
            title: "Product Sizes",
            icon: <Icon.Users size={16}/>,
            type: "item",
            navLink: "/product-sizes",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "companyProfile",
            title: "Company Profile",
            icon: <Icon.BookOpen size={16}/>,
            type: "item",
            navLink: "/company-profile",
            permissions: ["admin", "super", "editor"]
         },
         // {
         //    id: "branches",
         //    title: "Branch",
         //    icon: <Icon.Home size={16}/>,
         //    type: "item",
         //    navLink: "/branches",
         //    permissions: ["admin", "super", "editor"]
         // },
         {
            id: "otherExpenses",
            title: "Other Expenses",
            icon: <Icon.DollarSign size={16}/>,
            type: "item",
            navLink: "/others-expenses",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "Inventories",
            title: "Inventories",
            icon: <Icon.Home size={16}/>,
            type: "item",
            navLink: "/inventories",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: "Vat Types",
            title: "Vat Types",
            icon: <Icon.DollarSign size={16}/>,
            type: "item",
            navLink: "/vat-types",
            permissions: ["admin", "super", "editor"]
         },{

            id:"systemLog",
            title: "System Log",
            type: "item",
            icon: <Icon.List size={16}/>,
            navLink: "/system-log",
            permissions: ["admin", "super", "editor"]
         },
         {

            id:"backup",
            title: "Back Up",
            type: "item",
            icon: <Icon.Save size={16}/>,
            navLink: "/back-up",
            permissions: ["admin", "super", "editor"]
         },
         {
            id: 'logout',
            title: 'Logout',
            icon: <Icon.LogOut size={16}/>,
            type: 'item',
            navLink: '/logout'
         }
      ]
   },
]

export default horizontalMenuConfig
